var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaPublishedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0C4.48024 0 0.000244141 4.48 0.000244141 10C0.000244141 15.52 4.48024 20 10.0002 20C15.5202 20 20.0002 15.52 20.0002 10C20.0002 4.48 15.5202 0 10.0002 0ZM7.29025 14.29L3.70024 10.7C3.31024 10.31 3.31024 9.68 3.70024 9.29C4.09024 8.9 4.72024 8.9 5.11024 9.29L8.00025 12.17L14.8802 5.29C15.2702 4.9 15.9002 4.9 16.2902 5.29C16.6802 5.68 16.6802 6.31 16.2902 6.7L8.70024 14.29C8.32024 14.68 7.68024 14.68 7.29025 14.29Z",
    fill: "#1EBC61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaPublishedIcon);
export default __webpack_public_path__ + "static/media/RsaPublishedIcon.b19472a1d42b84fd65edda9ff836cd22.svg";
export { ForwardRef as ReactComponent };